var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "mb-4 text-xl font-bold text-center" }, [
        _vm._v(_vm._s(_vm.$t("trial.osTitle")))
      ]),
      _c(
        "v-row",
        { staticClass: "mb-4 justify-center" },
        [
          _c(
            "v-col",
            {
              attrs: { cols: "12", lg: "4" },
              on: {
                click: function($event) {
                  _vm.selected = "windows"
                }
              }
            },
            [
              _c(
                "va-card",
                {
                  staticClass:
                    "pa-6 d-flex flex-column align-center cursor-pointer",
                  class: [
                    _vm.selected === "windows"
                      ? "border-primary-a"
                      : "border-align"
                  ]
                },
                [
                  _c("windows-logo"),
                  _c("h2", { staticClass: "mt-3 font-bold" }, [
                    _vm._v("Windows")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: { cols: "12", lg: "4" },
              on: {
                click: function($event) {
                  _vm.selected = "android"
                }
              }
            },
            [
              _c(
                "va-card",
                {
                  staticClass:
                    "pa-6 d-flex flex-column align-center cursor-pointer",
                  class: [
                    _vm.selected === "android"
                      ? "border-primary-a"
                      : "border-align"
                  ]
                },
                [
                  _c("android-logo"),
                  _c("h2", { staticClass: "mt-3 font-bold" }, [
                    _vm._v("Android")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex justify-end flex-wrap" },
        [
          _c("va-button", {
            attrs: { disabled: !_vm.selected, cta: _vm.$t("trial.continue") },
            on: { click: _vm.onContinue }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }